import React, {Component} from 'react';

import { bindActionCreators } from 'redux';
import {connect} from 'react-redux';
import Loader from './../../components/Loader/Loader'
import fetchFeedingGuidelinesGenerateAction from './../../store/actions/fetch/fetchFeedingGuidelinesGenerateAction';
import * as actionTypes from './../../store/actions/feedingGuidelinesGenerateAction';
import GenerateButton from './../../components/FeedingGuidelines/GenerateButton';
import NotesInput from './../../components/FeedingGuidelines/NotesInput';
import {showPrintVersion, forceBiggerViewport} from '../../helpers/ScreenshotHelper';
import {getValidators} from '../../helpers/ValidationHelper';

import {isMobile} from 'react-device-detect';

import ReactModal from 'react-modal';

class Generate extends Component {

  componentDidMount() {
    const {fetchData} = this.props;
    fetchData();
  }

  /**
   * Validates the required inputs
   *
   * @param messages A validation error messages by key
   * @param validationState The application state
   * @returns boolean
   * @memberof Generate
   */
  validate(messages, validationState){
    let valid = true;
    let errorMessages = [];

    getValidators().forEach(validator => {
      // Clear any previous validation css
      let element = document.getElementById(validator['elementId']);
      if (element != null){
        element.classList.remove("nppe2-fc-invalid-input");
      }

      if (validator['elementId'] == "nppe2-fc-validate-birth-date"){
        document.querySelector(".nppe2-fc-birth-date__year .nppe2-fc-react-select").classList.remove("nppe2-fc-invalid-input");
        document.querySelector(".nppe2-fc-birth-date__month .nppe2-fc-react-select").classList.remove("nppe2-fc-invalid-input");
      }

      if (validator.key == "birthDate"){
        let months = parseInt(document.getElementsByName("nppe2-fc-breed-switcher-select-months")[0].value);
        let years = parseInt(document.getElementsByName("nppe2-fc-breed-switcher-select-years")[0].value);

        if ((isNaN(months) || months === 0) && (isNaN(years) || years === 0)){
          document.querySelector(".nppe2-fc-birth-date__year .nppe2-fc-react-select").classList.add("nppe2-fc-invalid-input");
          document.querySelector(".nppe2-fc-birth-date__month .nppe2-fc-react-select").classList.add("nppe2-fc-invalid-input");
          valid = false;
          errorMessages.push(messages[validator.key])
        }
      } else {
        let thisKey = validator['state'].split('.').reduce(function(accumulator, currentValue) {
          return accumulator[currentValue];
        }, validationState);

        // The key doesn't appear in the state || the value is empty
        if (validator['type'] == "string"){
          if (!thisKey || thisKey == ""){
            valid = false;
            element.classList.add("nppe2-fc-invalid-input");
            errorMessages.push(messages[validator.key])
          }
        }

        if (validator['type'] == "array"){
          if (
            !Object.keys(thisKey) ||
            Object.keys(thisKey).length == 0 ||
            Object.keys(thisKey).length == 1 && Object.values(thisKey)[0]["types"][0] === "supplement"
          ){
            valid = false;
            element.classList.add("nppe2-fc-invalid-input");
            errorMessages.push(messages[validator.key])
          }
        }

        if (validator['type'] == "notZero"){
          if (thisKey == null || parseFloat(thisKey) == 0){
            valid = false;
            element.classList.add("nppe2-fc-invalid-input");
            errorMessages.push(messages[validator.key])
          }
        }

        if (validator['type'] == "criticalCareNoDiagnoses") {
          if (thisKey && validationState.diagnosesReducer.selected.length == 0) {
            valid = false;
            element.classList.add("nppe2-fc-invalid-input");
            errorMessages.push(validationState.criticalCareReducer.data.help)
          }
        }
      }

    });


    // Clear the error messages or add them
    const errorMessageTarget = document.getElementById("nppe2-fc-validation-errors");
    errorMessageTarget.innerHTML = "";

    if (!valid){
      let errorsHtml = errorMessages.join("<br/>");
      errorMessageTarget.innerHTML = errorsHtml;
    }

    return valid;
  }

  render() {
    const {data, pending, ready, error, displayFeedingGuidelines, setNotes, validationState} = this.props;
    const {required} = data;

    if(pending || !ready) return (
      <Loader/>
    );

    return (
      <div>
        <NotesInput
          data={data}
          handleKeyUp={
            (event) => {
              setNotes(event.target.value);
            }
          }
        />

        <GenerateButton
          data={data}
          handleClick={() => {
            if (this.validate(required, validationState)){
              displayFeedingGuidelines()
              showPrintVersion()
              if(isMobile)
                forceBiggerViewport()
            }
          }}
        />

        <div id="nppe2-fc-validation-errors" class="nppe2-fc-validation-errors"></div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    data: state.feedingGuidelinesGenerateReducer.data,
    pending: state.feedingGuidelinesGenerateReducer.pending,
    ready: state.feedingGuidelinesGenerateReducer.ready,
    error: state.feedingGuidelinesGenerateReducer.error,
    validationState: state,
  }
};

const mapDispatchToProps = dispatch => {
  return {
    ...bindActionCreators(
      {
        fetchData: fetchFeedingGuidelinesGenerateAction
      },
      dispatch,
    ),
    displayFeedingGuidelines: () => dispatch({
      type: actionTypes.DISPLAY_FEEDING_GUIDELINES,
    }),
    setNotes: (notes) => dispatch({
      type: actionTypes.SET_NOTES,
      notes: notes,
    }),
    defaultValues: () => dispatch({
      type: actionTypes.DEFAULT,
    }),
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(Generate);
